import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { isRequired } from './required.helper';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[dmv-required]',
    standalone: false
})
export class RequiredDirective implements AfterViewInit {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('dmv-required') private formControl: AbstractControl;
    private elem: HTMLInputElement;

    constructor(private _elementRef: ElementRef) {
        this.elem = _elementRef.nativeElement as HTMLInputElement;
    }

    public ngAfterViewInit(): void {
        this.elem.required = isRequired(this.formControl);
    }
}
